import { useState, useContext, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/Drivers/DriverActiveRides/DriverActiveRides.css";
import DriverMasterLayout from "../../../layouts/Drivers/DriverMasterLayout";
import RideCard from "../../../components/Drivers/Rides/RideCard";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const DriverActiveRides = () => {
  const navigate = useNavigate();
  const [activeRides, setActiveRides] = useState([]);
  const { baseUrl, authToken, setSelectedRideforFindingDriver } = useContext(AppContext);

  const fetchActiveRideDetails = (status) => {
    const authToken = localStorage.getItem("authToken");
    const formData = new FormData();
    formData.append("status", status);
    axios
      .post(`${baseUrl}/driver/ride/viewActiveRides`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        console.log("driver active rides:", response.data);

        if (response.data.success === true) {
          setActiveRides(response.data.rides);
        }
      })
      .catch((error) => {
        console.log(error);
        alert("Network Error! Please try again.");
      });
  };
  useEffect(() => {
    console.log("log from useEffect");
    fetchActiveRideDetails("ongoing");
  }, []);

  const handleRideClick = (ride) => {
    console.log("Active ride clicked:", ride);
    setSelectedRideforFindingDriver(ride);
    navigate("/ride-onway");
  };

  return (
    <DriverMasterLayout screenName={"ActiveRides"} centered={true}>
      <div className="driver-active-rides-container">
        <Container className="driver-active-rides-content">
          {/* Active Rides List */}
          {activeRides.length > 0 ? (
            <div className="driver-active-rides-list">
              {activeRides.map((ride, index) => (
                <RideCard
                  key={index}
                  ride={ride}
                  showPickupButton={true}
                  showActionButtons={true}
                  onClick={() => handleRideClick(ride)}
                />
              ))}
            </div>
          ) : (
            /* Empty State */
            <div className="driver-active-rides-empty-state">
              <div className="driver-active-rides-empty-icon">🚗</div>
              <h5 className="driver-active-rides-empty-title">
                No Active Rides
              </h5>
              <p className="driver-active-rides-empty-text">
                Your active rides will appear here
              </p>
            </div>
          )}
        </Container>
      </div>
    </DriverMasterLayout>
  );
};

export default DriverActiveRides;
